(function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', () => {
      const {
        hydrateComponents
      } = window.PoleneLibs.Hydration;
      (async () => {
        const components = [Promise.resolve().then(function () { return collectionLoadMore$1; }), Promise.resolve().then(function () { return collectionInfiniteScroll$1; }), Promise.resolve().then(function () { return collectionFilters$1; }), Promise.resolve().then(function () { return collectionToggles$1; }), Promise.resolve().then(function () { return collectionMenu$1; }), Promise.resolve().then(function () { return collectionBackToTop$1; })];
        const componentsObj = hydrateComponents(components);
        await componentsObj.hydrate?.();
      })();
    });

    class CollectionLoadMore extends HTMLElement {
      btn = null;
      section = null;
      grid = null;
      bisModal = null;
      constructor() {
        super();
      }
      connectedCallback() {
        this.initializeElements();
        this.setupEventListeners();
      }
      disconnectedCallback() {
        this.removeEventListeners();
      }
      initializeElements = () => {
        this.btn = this.querySelector('button');
        this.section = this.closest(`[data-ref="collection-section"]`);
        this.bisModal = document.body.querySelector('component-modal[data-ref="bis-modal"]');
        if (this.section) this.grid = this.section.querySelector('[data-ref="grid"]');
      };
      setupEventListeners = () => {
        if (this.btn) this.btn.addEventListener('click', this.handleClick);
      };
      removeEventListeners = () => {
        if (this.btn) this.btn.removeEventListener('click', this.handleClick);
      };
      handleClick = () => {
        this.render();
      };
      render = () => {
        const {
          nextUrl
        } = this.dataset;
        if (!nextUrl) return;
        fetch(nextUrl).then(response => response.text()).then(responseText => {
          const htmlDocument = new DOMParser().parseFromString(responseText, 'text/html');
          this.renderNewProducts(htmlDocument);
          this.renderLoadMore(htmlDocument);
        }).catch(error => {
          alert('Failed to load more products. Please try again.');
        });
      };
      renderNewProducts = htmlDocument => {
        if (!this.grid) return;
        const newProducts = Array.from(htmlDocument.querySelectorAll('component-product-card'));
        const oldProducts = document.querySelectorAll('component-product-card');
        const fragment = document.createDocumentFragment();
        newProducts.forEach(product => fragment.appendChild(product));
        oldProducts.forEach(s => {
          s.removeAttribute('style');
        });
        this.grid.removeAttribute('style');
        this.grid.appendChild(fragment);
        this.bisModal?.reInit();
      };
      renderLoadMore = htmlDocument => {
        const newLoadMore = htmlDocument.querySelector('collection-load-more');
        if (!newLoadMore) return;
        const isHidden = this.classList.contains('hidden');
        this.dataset.currentPage = newLoadMore.dataset.currentPage;
        this.dataset.totalPages = newLoadMore.dataset.totalPages;
        this.dataset.nextUrl = newLoadMore.dataset.nextUrl;
        if (this.dataset.currentPage === this.dataset.totalPages && !isHidden) this.classList.add('hidden');else if (isHidden) this.classList.remove('hidden');
      };
      static define = () => {
        if (!customElements.get('collection-load-more')) {
          customElements.define('collection-load-more', CollectionLoadMore);
        }
      };
    }
    var collectionLoadMore = () => {
      CollectionLoadMore.define();
    };

    var collectionLoadMore$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        CollectionLoadMore: CollectionLoadMore,
        default: collectionLoadMore
    });

    const {
      BaseComponent: BaseComponent$2
    } = window.PoleneLibs.BaseComponent;
    const {
      getElementByRef: getElementByRef$1
    } = window.PoleneLibs.Refs;
    const {
      intersection
    } = window.PoleneLibs.Observer;
    const {
      dispatchEvent: dispatchEvent$1
    } = window.PoleneLibs.Utils;
    const ROOT_MARGIN_BOTTOM_DEFAULT_PX = 1200;
    const ROOT_MARGIN_BOTTOM_SMALL_PX = 600;
    class CollectionInfiniteScroll extends BaseComponent$2 {
      isLoading = false;
      bfcacheRestored = false;
      onMount() {
        this.initializeElements();
        this.setupEventListeners();
        if (this.bfcacheRestored) {
          this.bfcacheRestored = false;
          this.observeSentinel();
          return;
        }
        if (!this.restoreState()) {
          this.observeSentinel();
        }
      }
      onUnmount() {
        this.observer?.disconnect();
        this.observer = undefined;
        this.loadController?.abort();
        this.loadController = undefined;
      }
      initializeElements = () => {
        const {
          infiniteScrollSentinel
        } = getElementByRef$1('infinite-scroll-sentinel', this);
        this.sentinel = infiniteScrollSentinel;
        const {
          infiniteScrollLive
        } = getElementByRef$1('infinite-scroll-live', this);
        this.liveRegion = infiniteScrollLive;
        const {
          infiniteScrollSeoLink
        } = getElementByRef$1('infinite-scroll-seo-link', this);
        this.seoLink = infiniteScrollSeoLink;
        this.section = this.closest('[data-ref="collection-section"]') ?? undefined;
        this.bisModal = document.body.querySelector('component-modal[data-ref="bis-modal"]') ?? undefined;
        if (this.section) {
          this.grid = this.section.querySelector('[data-ref="grid"]') ?? undefined;
        }
      };
      setupEventListeners = () => {
        const {
          signal
        } = this.controller;
        window.addEventListener('COLLECTION_FILTERS_RENDERED', this.handleFiltersRendered, {
          signal
        });
        window.addEventListener('COLLECTION_LAYOUT_CHANGING', this.handleLayoutChanging, {
          signal
        });
        window.addEventListener('COLLECTION_LAYOUT_CHANGED', this.handleLayoutChanged, {
          signal
        });
        window.addEventListener('pageshow', this.handlePageShow, {
          signal
        });
        document.addEventListener('scrollend', this.handleScrollEnd, {
          signal
        });
      };
      handleFiltersRendered = () => {
        this.loadController?.abort();
        this.loadController = undefined;
        this.isLoading = false;
        this.grid?.setAttribute('aria-busy', 'false');
        this.resetState();
        this.observeSentinel();
      };
      handleLayoutChanging = () => {
        this.observer?.disconnect();
        this.loadController?.abort();
        this.loadController = undefined;
        this.isLoading = false;
        this.grid?.setAttribute('aria-busy', 'false');
      };
      handleLayoutChanged = () => this.observeSentinel();
      handlePageShow = event => {
        if (event.persisted) {
          this.bfcacheRestored = true;
        }
      };
      handleScrollEnd = () => {
        try {
          sessionStorage.setItem(this.getScrollStorageKey(), String(window.scrollY));
        } catch {}
      };
      observeSentinel = () => {
        this.observer?.disconnect();
        if (!this.sentinel) return;
        if (this.dataset.currentPage === this.dataset.totalPages) return;
        const rootMarginBottom = this.isCollectionLayoutSmall() ? ROOT_MARGIN_BOTTOM_SMALL_PX : ROOT_MARGIN_BOTTOM_DEFAULT_PX;
        this.observer = intersection(this.sentinel, this.handleIntersection, {
          rootMargin: `0px 0px ${rootMarginBottom}px 0px`,
          threshold: [0]
        });
      };
      handleIntersection = entries => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            this.loadNextPage();
          }
        }
      };
      loadNextPage = async () => {
        const {
          nextUrl,
          sectionId
        } = this.dataset;
        if (this.isLoading || !nextUrl || !this.grid) return;
        this.isLoading = true;
        this.grid.setAttribute('aria-busy', 'true');
        this.loadController?.abort();
        const localController = new AbortController();
        this.loadController = localController;
        try {
          const url = new URL(nextUrl, window.location.origin);
          url.searchParams.set('section_id', sectionId ?? '');
          const response = await fetch(url.toString(), {
            signal: localController.signal
          });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newProducts = doc.querySelectorAll('component-product-card');
          const fragment = document.createDocumentFragment();
          newProducts.forEach(product => fragment.appendChild(product));
          this.grid.appendChild(fragment);
          const newComponent = doc.querySelector('collection-infinite-scroll');
          if (newComponent) {
            this.dataset.currentPage = newComponent.dataset.currentPage;
            this.dataset.totalPages = newComponent.dataset.totalPages;
            this.dataset.nextUrl = newComponent.dataset.nextUrl;
          }
          this.updateSeoLink();
          this.cacheState();
          this.announceProducts(newProducts.length);
          this.bisModal?.reInit();
          dispatchEvent$1(window, 'PRODUCT_CARD_RENDERED');
          if (this.dataset.currentPage === this.dataset.totalPages) {
            this.observer?.disconnect();
            this.classList.add('hidden');
          } else {
            this.observeSentinel();
          }
        } catch (error) {
          if (error instanceof DOMException && error.name === 'AbortError') return;
        } finally {
          if (this.loadController === localController) {
            this.isLoading = false;
            this.grid?.setAttribute('aria-busy', 'false');
            this.loadController = undefined;
          }
        }
      };
      isCollectionLayoutSmall = () => {
        return this.closest('[data-layout]')?.dataset.layout === 'small';
      };
      announceProducts = count => {
        if (!this.liveRegion || !this.grid) return;
        const shown = this.grid.querySelectorAll('component-product-card').length;
        const total = parseInt(this.dataset.totalProducts ?? '0', 10);
        this.liveRegion.textContent = `${count} products added. Showing ${shown} of ${total} products.`;
      };
      updateSeoLink = () => {
        const {
          nextUrl
        } = this.dataset;
        if (!this.seoLink) return;
        if (this.dataset.currentPage === this.dataset.totalPages) {
          this.seoLink.remove();
          this.seoLink = undefined;
        } else if (nextUrl) {
          this.seoLink.href = nextUrl;
        }
      };
      getStorageKey = () => {
        const collectionId = this.dataset.collectionId ?? '';
        const searchParams = new URL(window.location.href).searchParams.toString();
        return `infinite-scroll:${collectionId}:${searchParams}`;
      };
      getScrollStorageKey = () => {
        const collectionId = this.dataset.collectionId ?? '';
        const searchParams = new URL(window.location.href).searchParams.toString();
        return `infinite-scroll-scrolly:${collectionId}:${searchParams}`;
      };
      restoreState = () => {
        try {
          const navEntry = performance.getEntriesByType('navigation')[0];
          if (navEntry?.type !== 'back_forward') return false;
          const key = this.getStorageKey();
          const raw = sessionStorage.getItem(key);
          if (!raw || !this.grid) return false;
          const cached = JSON.parse(raw);
          this.grid.innerHTML = cached.gridHTML;
          this.dataset.currentPage = cached.currentPage;
          this.dataset.totalPages = cached.totalPages;
          this.dataset.nextUrl = cached.nextUrl;
          this.updateSeoLink();
          this.bisModal?.reInit();
          dispatchEvent$1(window, 'PRODUCT_CARD_RENDERED');
          const scrollYRaw = sessionStorage.getItem(this.getScrollStorageKey());
          if (scrollYRaw) {
            void document.documentElement.scrollHeight;
            window.scrollTo({
              top: parseInt(scrollYRaw, 10),
              left: 0,
              behavior: 'instant'
            });
          }
          this.observeSentinel();
          return true;
        } catch {
          return false;
        }
      };
      cacheState = () => {
        if (!this.grid) return;
        try {
          const state = {
            gridHTML: this.grid.innerHTML,
            currentPage: this.dataset.currentPage ?? '1',
            totalPages: this.dataset.totalPages ?? '1',
            nextUrl: this.dataset.nextUrl ?? ''
          };
          sessionStorage.setItem(this.getStorageKey(), JSON.stringify(state));
        } catch {}
      };
      resetState = () => {
        try {
          const collectionId = this.dataset.collectionId ?? '';
          for (let i = sessionStorage.length - 1; i >= 0; i--) {
            const key = sessionStorage.key(i);
            if (key?.startsWith(`infinite-scroll:${collectionId}:`) || key?.startsWith(`infinite-scroll-scrolly:${collectionId}:`)) {
              sessionStorage.removeItem(key);
            }
          }
        } catch {}
        this.observer?.disconnect();
      };
      static define = () => {
        if (!customElements.get('collection-infinite-scroll')) {
          customElements.define('collection-infinite-scroll', CollectionInfiniteScroll);
        }
      };
    }
    var collectionInfiniteScroll = () => {
      CollectionInfiniteScroll.define();
    };

    var collectionInfiniteScroll$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        CollectionInfiniteScroll: CollectionInfiniteScroll,
        default: collectionInfiniteScroll
    });

    const {
      dispatchEvent
    } = window.PoleneLibs.Utils;
    const SELECTORS = {
      DRAWER: 'component-drawer',
      OPEN_BTN: '[data-ref="filters-open-btn"]',
      CLEAR_BTN: '[data-ref="filters-clear-btn"]',
      APPLY_BTN: '[data-ref="filters-apply-btn"]',
      COUNTER: '[data-ref="filters-counter"]',
      GRID: '[data-ref="grid"]',
      LOAD_MORE: 'collection-load-more, collection-infinite-scroll',
      INPUT: 'input'
    };
    class CollectionFilters extends HTMLElement {
      openButton = null;
      clearButton = null;
      applyButton = null;
      drawer = null;
      section = null;
      renderedSections = {};
      inputs = [];
      counters = [];
      grid = null;
      loadMore = null;
      constructor() {
        super();
      }
      connectedCallback() {
        this.initializeElements();
        this.setupEventListeners();
      }
      disconnectedCallback() {
        this.removeEventListeners();
      }
      initializeElements = () => {
        this.drawer = this.querySelector(SELECTORS.DRAWER);
        this.openButton = this.querySelector(SELECTORS.OPEN_BTN);
        this.clearButton = this.querySelector(SELECTORS.CLEAR_BTN);
        this.applyButton = this.querySelector(SELECTORS.APPLY_BTN);
        this.counters = Array.from(this.querySelectorAll(SELECTORS.COUNTER));
        this.section = this.closest(`[data-id="${this.dataset.sectionId}"]`);
        this.inputs = Array.from(this.querySelectorAll(SELECTORS.INPUT));
        if (this.section) {
          this.loadMore = this.section.querySelector(SELECTORS.LOAD_MORE);
          this.grid = this.section.querySelector(SELECTORS.GRID);
        }
      };
      setupEventListeners = () => {
        this.openButton?.addEventListener('click', this.handleOpen);
        this.clearButton?.addEventListener('click', this.handleClear);
        this.applyButton?.addEventListener('click', this.handleClose);
        this.inputs.forEach(input => input.addEventListener('click', this.handleInputClick));
        window.addEventListener('popstate', this.handlePopstate);
      };
      removeEventListeners = () => {
        this.openButton?.removeEventListener('click', this.handleOpen);
        this.clearButton?.removeEventListener('click', this.handleClear);
        this.applyButton?.removeEventListener('click', this.handleClose);
        this.inputs.forEach(input => input.removeEventListener('click', this.handleInputClick));
        window.removeEventListener('popstate', this.handlePopstate);
      };
      handleOpen = () => {
        window?.zE?.('messenger', 'hide');
        this.drawer?.open();
      };
      handleClose = () => {
        window?.zE?.('messenger', 'show');
        this.drawer?.close();
      };
      handleClear = () => {
        this.inputs.forEach(input => {
          input.checked = false;
          input.disabled = false;
        });
        this.render();
      };
      handlePopstate = event => this.render(event.state.searchParams);
      handleInputClick = event => {
        const target = event.target;
        const form = target.closest('form');
        if (!form) return;
        const searchParams = this.createSearchParams(form);
        this.render(searchParams);
      };
      render = (searchParams = '') => {
        const sectionId = this.dataset.sectionId;
        const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
        this.renderSection(url);
        this.updateURLHash(searchParams);
      };
      renderSection = url => {
        if (url in this.renderedSections) this.renderElements(this.renderedSections[url], url);else {
          fetch(url).then(response => response.text()).then(responseText => {
            const newSection = new DOMParser().parseFromString(responseText, 'text/html');
            this.renderedSections[url] = newSection;
            this.renderElements(newSection, url);
          }).catch(error => {});
        }
      };
      renderElements = (newSection, url) => {
        this.renderGrid(newSection);
        this.renderCounters(newSection);
        this.renderLoadMore(newSection);
        this.renderInputs(newSection);
        dispatchEvent(window, 'COLLECTION_FILTERS_RENDERED', {
          url: url || window.location.href,
          sectionId: this.dataset.sectionId
        });
      };
      renderInputs = newSection => {
        const newInputs = Array.from(newSection.querySelectorAll(SELECTORS.INPUT));
        this.inputs.forEach((input, index) => {
          if (input.id === newInputs[index].id) input.disabled = newInputs[index].disabled;else {
            const matchingNewInput = newInputs.find(newLabel => newLabel.id === input.id);
            if (matchingNewInput) input.disabled = matchingNewInput.disabled;
          }
        });
      };
      renderCounters = newSection => {
        const newCounters = Array.from(newSection.querySelectorAll(SELECTORS.COUNTER));
        const newApplyBtn = newSection.querySelector(SELECTORS.APPLY_BTN);
        if (!newApplyBtn || !this.applyButton) return;
        this.applyButton.innerHTML = newApplyBtn.innerHTML;
        this.counters.forEach((counter, index) => counter.innerHTML = newCounters[index].innerHTML);
      };
      renderLoadMore = newSection => {
        const newLoadMore = newSection.querySelector(SELECTORS.LOAD_MORE);
        if (!this.loadMore || !newLoadMore) return;
        this.loadMore.className = newLoadMore.className;
        this.loadMore.dataset.currentPage = newLoadMore.dataset.currentPage;
        this.loadMore.dataset.totalPages = newLoadMore.dataset.totalPages;
        this.loadMore.dataset.nextUrl = newLoadMore.dataset.nextUrl;
      };
      renderGrid = newSection => {
        const newGrid = newSection.querySelector(SELECTORS.GRID);
        if (!newGrid || !this.grid) return;
        this.grid.innerHTML = newGrid.innerHTML;
      };
      updateURLHash = searchParams => {
        history.pushState({
          searchParams
        }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
      };
      createSearchParams = form => {
        const formData = new FormData(form);
        const params = new URLSearchParams();
        formData.forEach((value, key) => {
          if (typeof value === 'string') {
            params.append(key, value);
          }
        });
        return params.toString();
      };
      static define = () => {
        if (!customElements.get('collection-filters')) {
          customElements.define('collection-filters', CollectionFilters);
        }
      };
    }
    var collectionFilters = () => {
      CollectionFilters.define();
    };

    var collectionFilters$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        CollectionFilters: CollectionFilters,
        default: collectionFilters
    });

    const {
      BaseComponent: BaseComponent$1
    } = window.PoleneLibs.BaseComponent;
    const {
      getElementsByRef: getElementsByRef$1
    } = window.PoleneLibs.Refs;
    const {
      flip
    } = window.PoleneLibs.FlipAnimation;
    const {
      scrollToPosition
    } = window.PoleneLibs.Utils;
    const CLASSES$1 = {
      active: 'is-active'
    };
    class CollectionToggles extends BaseComponent$1 {
      toggles = [];
      onMount() {
        this.initializeElements();
        this.setupEventListeners();
        this.setGridLayout(this.getLayoutFromParams());
      }
      initializeElements = () => {
        const {
          toggles
        } = getElementsByRef$1('toggles', this);
        this.section = this.closest('[data-ref="collection-section"]') ?? undefined;
        this.toggles = toggles ? Array.isArray(toggles) ? toggles : [toggles] : [];
      };
      setupEventListeners = () => {
        const {
          signal
        } = this.controller;
        this.toggles.forEach(toggle => toggle.addEventListener('click', this.handleLayoutClick, {
          signal
        }));
      };
      handleLayoutClick = event => {
        const target = event.currentTarget;
        const {
          type
        } = target.dataset;
        if (!type || type === this.currentLayout) return;
        flip('grid', () => {
          scrollToPosition(0, 1000);
          this.setGridLayout(type);
          this.updateUrl(type);
        });
      };
      setGridLayout = selectedLayout => {
        if (!this.section) return;
        const layout = selectedLayout ?? this.section.dataset.defaultLayout ?? 'big';
        this.currentLayout = layout;
        this.section.dataset.layout = layout;
        this.toggles.forEach(toggle => {
          toggle.classList.toggle(CLASSES$1.active, toggle.dataset.type === layout);
        });
      };
      getLayoutFromParams = () => {
        const params = new URLSearchParams(window.location.search);
        return params.get('layout');
      };
      updateUrl = layout => {
        const url = new URL(window.location.href);
        url.searchParams.set('layout', layout);
        history.replaceState({}, '', url);
      };
      static define = () => {
        if (!customElements.get('collection-toggles')) {
          customElements.define('collection-toggles', CollectionToggles);
        }
      };
    }
    var collectionToggles = () => {
      CollectionToggles.define();
    };

    var collectionToggles$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        CollectionToggles: CollectionToggles,
        default: collectionToggles
    });

    const {
      getElementsByRef
    } = window.PoleneLibs.Refs;
    const classes = {
      overflowLeft: 'has-overflow-left',
      overflowRight: 'has-overflow-right'
    };
    var collectionMenu = () => {
      const {
        collectionMenu,
        collectionMenuList,
        collectionMenuInner,
        buttonLeft,
        buttonRight
      } = getElementsByRef(['collection-menu', 'collection-menu-list', 'collection-menu-inner', 'button-left', 'button-right']);
      if (!collectionMenu || !collectionMenuList || !collectionMenuInner || !buttonLeft || !buttonRight) return;
      const filters = Array.isArray(collectionMenu) ? [...collectionMenu] : [collectionMenu];
      if (!filters) return;
      const init = () => {
        setEventListeners();
        checkOverflow();
      };
      const setEventListeners = () => {
        window.addEventListener('resize', checkOverflow);
        if (!Array.isArray(collectionMenuList)) collectionMenuList.addEventListener('scroll', checkOverflow);else collectionMenuList.forEach(list => list.addEventListener('scroll', checkOverflow));
        if (!Array.isArray(buttonLeft)) buttonLeft.addEventListener('click', goLeft);else buttonLeft.forEach(button => button.addEventListener('click', goLeft));
        if (!Array.isArray(buttonRight)) buttonRight.addEventListener('click', goRight);else buttonRight.forEach(button => button.addEventListener('click', goRight));
      };
      filters.forEach(filter => {
        const activeLink = filter.querySelector('.active');
        if (!activeLink) return;
        activeLink.scrollIntoView({
          block: 'nearest',
          inline: 'center',
          behavior: 'smooth'
        });
      });
      const checkOverflow = () => {
        if (Array.isArray(collectionMenuList) || Array.isArray(collectionMenuInner)) return;
        const isOverflowingRight = collectionMenuList.scrollWidth - collectionMenuList.scrollLeft - 12.5 > collectionMenuInner.clientWidth;
        const isOverflowingLeft = collectionMenuList.scrollLeft > 0;
        collectionMenuInner.classList.toggle(classes.overflowLeft, isOverflowingLeft);
        collectionMenuInner.classList.toggle(classes.overflowRight, isOverflowingRight);
      };
      const goLeft = () => {
        if (Array.isArray(collectionMenuList)) return;
        collectionMenuList.scrollTo({
          left: 0,
          behavior: 'smooth'
        });
      };
      const goRight = () => {
        if (Array.isArray(collectionMenuList)) return;
        collectionMenuList.scrollTo({
          left: collectionMenuList.scrollWidth - collectionMenuList.clientWidth,
          behavior: 'smooth'
        });
      };
      init();
      return () => {
        window.removeEventListener('resize', checkOverflow);
        if (!Array.isArray(collectionMenuList)) collectionMenuList.removeEventListener('scroll', checkOverflow);else collectionMenuList.forEach(list => list.removeEventListener('scroll', checkOverflow));
        if (!Array.isArray(buttonLeft)) buttonLeft.removeEventListener('click', goLeft);else buttonLeft.forEach(button => button.removeEventListener('click', goLeft));
        if (!Array.isArray(buttonRight)) buttonRight.removeEventListener('click', goRight);else buttonRight.forEach(button => button.removeEventListener('click', goRight));
      };
    };

    var collectionMenu$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: collectionMenu
    });

    const cleanPath = path => path.replace(/\/+/g, '/');
    const cleanPaths = paths => {
      return Object.fromEntries(Object.entries(paths).map(([key, path]) => [key, cleanPath(path)]));
    };
    const ROOT_PATH = window?.Shopify?.routes?.root || '/';
    cleanPath(`${ROOT_PATH}/apps/polene-theme-features`);
    cleanPaths({
      WISHLIST: `${ROOT_PATH}/pages/wishlist`,
      ACCOUNT: `${ROOT_PATH}/account`,
      LOGIN: `${ROOT_PATH}/account/login`,
      LOGIN_MULTI_PASS: `${ROOT_PATH}/account/login/multipass`
    });
    window.P1?.klaviyo?.public_key;
    window.P1?.klaviyo?.list_id;
    const FOCUSABLE_SELECTORS = ['button:not([disabled])', '[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', '[tabindex]:not([tabindex="-1"]):not([disabled])'].join(', ');

    const {
      BaseComponent
    } = window.PoleneLibs.BaseComponent;
    const {
      getElementByRef
    } = window.PoleneLibs.Refs;
    const {
      prefersReducedMotion
    } = window.PoleneLibs.Utils;
    const CLASSES = {
      visible: 'is-visible',
      bodyVisible: 'scroll-to-top-visible'
    };
    class CollectionBackToTop extends BaseComponent {
      button = undefined;
      collection = null;
      onMount() {
        this.initializeElements();
        this.setupEventListeners();
      }
      onUnmount() {
        document.body.classList.remove(CLASSES.bodyVisible);
      }
      initializeElements = () => {
        const {
          collectionBackToTopBtn
        } = getElementByRef('collection-back-to-top-btn', this);
        this.button = collectionBackToTopBtn;
        this.collection = this.closest('[data-ref="collection-section"]');
      };
      setupEventListeners = () => {
        const {
          signal
        } = this.controller;
        window.addEventListener('scroll', this.handleScroll, {
          passive: true,
          signal
        });
        this.button?.addEventListener('click', this.handleClick, {
          signal
        });
      };
      handleScroll = () => {
        const scrolled = window.scrollY > window.innerHeight;
        this.classList.toggle(CLASSES.visible, scrolled);
        document.body.classList.toggle(CLASSES.bodyVisible, scrolled);
      };
      handleClick = () => {
        window.scrollTo({
          top: 0,
          behavior: prefersReducedMotion() ? 'auto' : 'smooth'
        });
        this.collection?.querySelector(FOCUSABLE_SELECTORS)?.focus();
      };
      static define = () => {
        if (!customElements.get('collection-back-to-top')) {
          customElements.define('collection-back-to-top', CollectionBackToTop);
        }
      };
    }
    var collectionBackToTop = () => {
      CollectionBackToTop.define();
    };

    var collectionBackToTop$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: collectionBackToTop
    });

})();
